import { createContext, useContext, useState, useCallback } from "react";
import { buildChangeList } from "../utils/changeTracking";

const ChangeTrackingContext = createContext(null);

export const ChangeTrackingProvider = ({ children }) => {
	const [changes, setChanges] = useState([]);
	
	const rebuildChanges = useCallback((draftData, fetchedData) => {
		const newChanges = buildChangeList(draftData, fetchedData);
		setChanges(newChanges);
		return newChanges.length > 0;
	}, []);
	
	const resetChanges = useCallback(() => {
		setChanges([]);
	}, []);

	return (
		<ChangeTrackingContext.Provider value={{ changes, rebuildChanges, resetChanges }}>
			{children}
		</ChangeTrackingContext.Provider>
	);
};

export const useChangeTracking = () => useContext(ChangeTrackingContext);